class ProductKits {
  constructor() {
    this.kitTriggers = document.querySelectorAll('[data-kit-trigger]');
    this.kitContents = document.querySelectorAll('[data-kit-content]');

    this._init();
  }

  _init() {
    this.kitTriggers.forEach(trigger => {
      trigger.addEventListener(
        'click',
        this._handleTriggerClick.bind(this, trigger),
      );
    });

  }

  _handleTriggerClick(trigger) {
    const kitHandle = trigger.getAttribute('data-kit-trigger');
    
    this.kitContents.forEach( kit => {
      if (kit.getAttribute('data-kit-content') === kitHandle) {
        kit.classList.add('product-kits__tab-content--open');
      } else {
        kit.classList.remove('product-kits__tab-content--open');
      }
    });

    this.kitTriggers.forEach( trigger => {
      if (trigger.getAttribute('data-kit-trigger') === kitHandle) {
        trigger.classList.add('product-kits__tab-trigger--open');
      } else {
        trigger.classList.remove('product-kits__tab-trigger--open');
      }
    });
  }
}

document.addEventListener('page:loaded', function() {
  const kitComparison = document.querySelector('[data-kit-comparison]');
    if (kitComparison) {
      new ProductKits();
  }
});

